import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppConstants } from '@app/@core/entities/app-constants';
import { HttpService } from '@app/@core/services/http.service';
import { AlertService } from '@core/services/alert.service';
import { FormControl, Validators } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'app-delete',
  templateUrl: './delete.component.html',
  styleUrls: ['./delete.component.scss']
})
export class DeleteComponent implements OnInit{
  deleteId: string;
  message: string;
  url: string;
  portConfig: string;
  successMsg: string;
  action: string;
  data: any;
  value: any;
  reasonStatus: boolean;
  enteredReason: string;
  isDisabled: boolean = false;
  reasonFormControl: FormControl;
  rowData: any = {};

  constructor(
    private httpService: HttpService,
    private alert: AlertService,
    public dialogRef: MatDialogRef<DeleteComponent>,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    if (data?.deleteId && data?.deleteId !== '' && data?.url && data?.url !== '') {
      this.deleteId = data.deleteId;
      this.action = data.action;
      this.reasonStatus = data.reasonStatus ?? false;
      this.message = data?.message ? data.message : 'Are you sure want to delete this record ?';
      this.url = data.url;
      this.portConfig = data.portConfig;
      this.successMsg = data?.successMsg ? data.successMsg : 'Deleted Successfully';
      this.data = data;
      this.enteredReason = '';
      this.rowData = {'data': data.rowData};
      if(this.reasonStatus){
        this.isDisabled = true;
      }
    }
  }

  ngOnInit(): void {
    this.reasonFormControl = new FormControl('', Validators.required);
  }

  deleteRecord(): void {
    if (this.action === 'update_activation') {
      this.updateActivation();
    } else if (this.action === 'update') {
      this.updateRecord();
    } else if (this.action === 'complete') {
      this.completeRecord();
    } else if (this.action === 'page_activation') {
      this.deactivatePage();
    } else {
      if(this.reasonStatus){
        this.rowData = {...this.rowData, 'reason' :this.enteredReason};
            this.httpService.post(`${this.url}/${this.deleteId}`, this.rowData).subscribe(
              _result1 => {
                this.closePopup('yes');
                this.alert.success(this.successMsg);
              }, 
              _error => {
                this.closePopup();
                this.alert.error(AppConstants.errorMessage);
              }
            );
      } else {
        this.httpService.delete(`${this.url}/${this.deleteId}`).subscribe(
          _result => {
            this.closePopup('yes');
          },
          _error => {
            this.closePopup();
            this.alert.error(AppConstants.errorMessage);
          }
        );
      }
    }
  }
  
  deactivatePage() {
    this.httpService.patch(this.url).subscribe(
      _result => {
        this.closePopup('yes');
        this.alert.success(this.successMsg);
      },
      _error => {
        this.closePopup();
        this.alert.error('Failed to deactivate page. Please try again.');
      }
    );
  }

  updateRecord() {
    this.httpService.put(this.url, this.deleteId).subscribe(
      _result => {
        this.closePopup();
        this.alert.success(this.successMsg);
      },
      _error => {
        this.closePopup();
        this.alert.error(AppConstants.errorMessage);
      }
    );
  }
  closePopup(deleteData = null) {
    this.dialogRef.close({ data: deleteData });
  }

  completeRecord() {
    this.data.data.status = 'Closed';
    this.data.data.statuskey = '81C';
    this.data.data.completeddate = new Date().toISOString();
    this.httpService
      .post(this.url, {
        data: this.data.data
      })
      .subscribe(
        _result => {
          this.closePopup();
          this.alert.success(this.successMsg);
        },
        _error => {
          this.closePopup();
          this.alert.error(AppConstants.errorMessage);
        }
      );
  }
  updateActivation() {
    const userData = this.data.data;
    userData.isactive = userData.isactive === true ? false : true;
    this.httpService.post(this.url, [userData]).subscribe(
      _result => {
        this.closePopup();
        this.alert.success(this.successMsg);
      },
      error => {
        this.closePopup();
        console.log(error);
      }
    );
  }

  checkIsDisabled(text: string){
    if(text && text.trim() != ''){
      this.isDisabled = false;
      this.enteredReason = text;
    } else {
      this.isDisabled = true;
      this.enteredReason = text;
    }
  }
}
